define.alias("shared/utils/array-filters/get-last-value", "settings/utils/array-filters/get-last-value");